import { render, staticRenderFns } from "./Cargando.vue?vue&type=template&id=cfbf2abc"
import script from "./Cargando.vue?vue&type=script&lang=js"
export * from "./Cargando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports